/* eslint-disable no-shadow */
/* eslint-disable react/jsx-props-no-spreading */
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useMutation } from '@apollo/client';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { compose, bindActionCreators } from 'redux';
import {
  Container,
  Grid as SemanticGrid,
  Loader,
} from 'semantic-ui-react';
import { ConfirmDialog, captureException } from '@playbookux/playbook-web-core';
import _ from 'lodash';
import Cell from './cell';

import withLayout from '../../../core/components/with-layout';

import {
  Main,
  DangerText,
  DeleteAccountContainer,
  DeleteText,
  DeleteButton,
  ContainerButton,
  NotificationText,
  NotificationHeader,
  NotificationContainer,
} from './styles';

import { DELETE_USER } from './graphql';

import { setNotification } from './actions';

const AccountSettings = (props) => {
  const {
    status,
    profile,
    onSignOut,
    me: { user_id: userId = '' } = {},
    setNotification,
    alert,
  } = props;

  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [deleteUser] = useMutation(DELETE_USER);

  const handleNotification = () => {
    setNotification(!alert.notification);
  };
  window.visibleNotification = alert.notification;
  const handleDeleteUser = async () => {
    try {
      if (_.isEmpty(userId)) return;
      await deleteUser({ variables: { userId } });
      onSignOut();
    } catch (e) {
      captureException('DELETE_USER_FAILURE', e);
    }
  };

  if (status && status.isLoading) {
    return (
      <div>
        <SemanticGrid container verticalAlign="middle">
          <Loader active data-loader="account-loader" />
        </SemanticGrid>
      </div>
    );
  }

  return (
    <Main>
      <Container>
        <NotificationContainer>
          <NotificationHeader>Notifications</NotificationHeader>
          <NotificationText>Sound alert when a new study is available:</NotificationText>
          <Cell
            name="notification"
            checked={alert.notification}
            onChange={handleNotification}
          />
        </NotificationContainer>
        {profile && (
          <DeleteAccountContainer>
            <DangerText>Danger Zone: Delete Account</DangerText>
            <DeleteText>-You will no longer have access to this account</DeleteText>
            <DeleteText>-Please make sure all outstanding payments are paid before deleting</DeleteText>
            <DeleteText>
              -This is permanent and cannot be undone.
              <a>Learn more</a>
            </DeleteText>
            <ContainerButton>
              <DeleteButton
                onClick={() => setShowDeleteModal(true)}
              >
                Delete Account
              </DeleteButton>
            </ContainerButton>

          </DeleteAccountContainer>
        )}

      </Container>
      <ConfirmDialog
        show={showDeleteModal}
        title="Delete account?"
        warning="Warning: This cannot be undone"
        confirmText="Yes, delete my account"
        cancelText="Cancel, keep my  account"
        handleConfirm={handleDeleteUser}
        handleClose={() => setShowDeleteModal(false)}
      />
    </Main>
  );
};

AccountSettings.defaultProps = {
  status: '',
  isLoading: false,
};

AccountSettings.propTypes = {
  me: PropTypes.shape({
    user_id: PropTypes.string,
  }).isRequired,
  onSignOut: PropTypes.func.isRequired,
  profile: PropTypes.shape({
    id: PropTypes.string,
    username: PropTypes.string,
  }).isRequired,
  errors: PropTypes.shape({
    jobsSelected: PropTypes.any,
  }).isRequired,
  isLoading: PropTypes.bool,
  status: PropTypes.string,
  setNotification: PropTypes.func.isRequired,
  alert: PropTypes.bool.isRequired,
};

const mapStateToProps = ({ authentication, notification }) => ({
  profile: authentication.profile,
  alert: notification,
});

const mapDispatchToProps = (dispatch) => bindActionCreators(
  {
    setNotification,
  },
  dispatch,
);

export default compose(withLayout({ selectedTab: 'Settings' }),
  withRouter,
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ))(AccountSettings);
